export default __webpack_public_path__ + "media/images/gear-916f3e6298905e12bf2ef4ea397e7e55.png";